import "./PoliticaDePrivacidade.css";

function PoliticaDePrivacidade() {
  return (
    <main className="politica-container">
      <h1>Política de Privacidade</h1>

      <p>
        A Eliandro Alimentos respeita a sua privacidade e está comprometida com a
        proteção dos dados pessoais de seus clientes, parceiros e usuários,
        conforme a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).
      </p>

      <section>
        <h2>1. Coleta de dados</h2>
        <p>
          Coletamos dados pessoais fornecidos voluntariamente pelo usuário por
          meio de formulários, contato via WhatsApp, e-mail ou outros canais de
          comunicação disponíveis em nosso site.
        </p>
        <p>
          Os dados coletados podem incluir nome, telefone, e-mail, endereço e
          outras informações necessárias para atendimento e relacionamento
          comercial.
        </p>
      </section>

      <section>
        <h2>2. Uso das informações</h2>
        <p>
          Os dados coletados são utilizados para:
        </p>
        <ul>
          <li>Atendimento ao cliente</li>
          <li>Envio de informações solicitadas</li>
          <li>Relacionamento comercial</li>
          <li>Cumprimento de obrigações legais</li>
        </ul>
      </section>

      <section>
        <h2>3. Compartilhamento de dados</h2>
        <p>
          A Eliandro Alimentos não vende ou compartilha dados pessoais com
          terceiros, exceto quando necessário para o cumprimento de obrigações
          legais ou para a prestação dos serviços solicitados pelo usuário.
        </p>
      </section>

      <section>
        <h2>4. Segurança dos dados</h2>
        <p>
          Adotamos medidas técnicas e organizacionais adequadas para proteger os
          dados pessoais contra acessos não autorizados, perda, alteração ou
          divulgação indevida.
        </p>
      </section>

      <section>
        <h2>5. Direitos do titular</h2>
        <p>
          O usuário pode, a qualquer momento, solicitar acesso, correção ou
          exclusão de seus dados pessoais, bem como esclarecer dúvidas sobre o
          tratamento dessas informações.
        </p>
      </section>

      <section>
        <h2>6. Contato</h2>
        <p>
          Para qualquer dúvida relacionada a esta Política de Privacidade,
          entre em contato pelo e-mail:
        </p>
        <p className="email">
          atendimento@eliandroalimentos.com.br
        </p>
      </section>

      <p className="atualizacao">
        Última atualização: Janeiro de 2026
      </p>
    </main>
  );
}

export default PoliticaDePrivacidade;
